import apiHeader from '@/helpers/apiHeader';

const standarItemNameService = {
    list(params) {
        return apiHeader.get('dictionary/standard-item-name/item-name', { params });
    },
    create(params) {
        return apiHeader.post('dictionary/standard-item-name/item-name', params);
    },
    update(id, params) {
        return apiHeader.put(`dictionary/standard-item-name/item-name/${id}`, params);
    },
    delete(id) {
        return apiHeader.delete(`dictionary/standard-item-name/item-name/${id}`);
    },
    detail(id) {
        return apiHeader.get(`dictionary/standard-item-name/item-name/${id}`);
    },
    patch(id, params) {
        return apiHeader.patch(`dictionary/standard-item-name/item-name/${id}`, params);
    },
    // Colloquial Tabs methods
    createColloquial(params) {
        return apiHeader.post('dictionary/standard-item-name/colloquial', params);
    },
    deleteColloquial(id) {
        return apiHeader.delete(`dictionary/standard-item-name/colloquial/${id}`);
    },
    // Material Type Tabs methods
    createMaterialType(params) {
        return apiHeader.post('dictionary/standard-item-name/material-type', {
            inc: params.inc,
            material_type: params.material_type
        });
    },
    deleteMaterialType(id) {
        return apiHeader.delete(`dictionary/standard-item-name/material-type/${id}`);
    },
    // Material Group Tabs methods
    createMaterialGroup(params) {
        return apiHeader.post('dictionary/standard-item-name/material-group', {
            inc: params.inc,
            material_group: params.material_group
        });
    },
    deleteMaterialGroup(id) {
        return apiHeader.delete(`dictionary/standard-item-name/material-group/${id}`);
    },

    // NGC Tabs methods
    listNGC(params) {
        return apiHeader.get('dictionary/unspsc', { params });
    },
    detailsNGC(id) {
        return apiHeader.get(`dictionary/standard-item-name/unspsc/${id}`);
    },
    createUnspsc(params) {
        return apiHeader.post('dictionary/standard-item-name/unspsc', params);
    },
    deleteUnspsc(id) {
        return apiHeader.delete(`dictionary/standard-item-name/unspsc/${id}`);
    },
    // Mendapatkan URL gambar by id
    getImageUrlById(id, config = {}) {
        return apiHeader.get(`dictionary/standard-item-name/image/get-image/${id}`, config);
    },
    uploadImage(formData) {
        return apiHeader.post('dictionary/standard-item-name/image', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    deleteImage(id) {
        return apiHeader.delete(`dictionary/standard-item-name/image/${id}`);
    },
    // Service Category Tabs methods
    createServiceCategory(params) {
        return apiHeader.post('dictionary/standard-item-name/service-category', { inc: params.inc, service_category: params.service_category });
    },
    deleteServiceCategory(id) {
        return apiHeader.delete(`dictionary/standard-item-name/service-category/${id}`);
    },
    // Service Group Tabs methods
    createServiceGroup(params) {
        return apiHeader.post('dictionary/standard-item-name/service-group', { inc: params.inc, service_group: params.service_group });
    },
    deleteServiceGroup(id) {
        return apiHeader.delete(`dictionary/standard-item-name/service-group/${id}`);
    },
}

export default standarItemNameService;
